export function getMyLoginFromAccessToken(
  accessToken: string,
  decoder: AuthTokenDecoder
): string | null {
  return decoder.extractEmail(accessToken);
}

export type Email = string | null;

export interface AuthTokenDecoder {
  extractEmail(token: string): Email;
}
